// extracted by mini-css-extract-plugin
export default {"project":"Project_project__Avww3","description":"Project_description__crNRs","gallery":"Project_gallery__nXSA1"};